import { action, observable } from 'mobx';
import { accountApi } from '@link/triplabo/services';
import { Account as AccountType } from '@link/triplabo/services/types';

export class Account {
  @observable accessor accountInfo: AccountType = {};

  @action
  getAccountInfo() {
    return accountApi.getAccount().then(res => {
      const account = res.account ?? ({} as AccountType);
      this.setAccountInfo(account);
      return account;
    });
  }

  @action
  setAccountInfo(account: AccountType) {
    this.accountInfo = account;
  }

  @action
  submitAccountInfo(account: AccountType) {
    return accountApi.updateAccount({
      body: {
        account: account
      }
    });
  }
}

export default new Account();
